import React from "react";
import { StaticDatePicker } from "@mui/x-date-pickers";
import { MenuItem, Box, Select, FormControl } from "@mui/material";
import { ArrowRightIcon, ArrowLeftIcon } from '@mui/x-date-pickers';
import { DateTime } from "luxon";
import PropTypes from 'prop-types';
import { DAYS_OFF } from "../utils/LSDaysOff";

const CustomToolbar = ({setValue, className, months}) => {

  const setTarget = (date) => {
    setValue(date)
  }

  return (
    <Box
      // Pass the className to the root element to get correct layout
      className={className}
      sx={{ display: 'flex', alignItems: 'center', justifyContent: 'start', paddingX: '.8em', paddingTop: '.8em', position: 'absolute', width: '25%'}}
    >
      <FormControl size="small" fullWidth>
        <Select
          labelId='demo-simple-select-label'
          id='demo-simple-select'
        >
          {
            months.map((month, index) =>
            <MenuItem key={index} value={month} onClick={() => setTarget(DateTime.now().plus({months: index}))}>
              { index === 0 ? (
                'Today'
              ) : (
                <>
                  {month} {DateTime.now().plus({months: index}).year}
                </>
              )}
            </MenuItem>
            )
          }
        </Select>
      </FormControl>
    </Box>
  )

}

CustomToolbar.propTypes = {
  setValue: PropTypes.func,
  className: PropTypes.string,
  months: PropTypes.array
}

const NextApptCalendar = ({value, setValue, readOnly}) => {

  let months = [];

  for (let index = 0; index < 7; index++) {
    const month = DateTime.now().plus({ months: index }).monthLong
    months.push(month)
  }

  const shouldDisableDate = (date, daysOff = DAYS_OFF) => {

    // Disable for Sundays
    const day = date.weekday;
    if(day === 7) {
      return true
    }
    
    // Disable for specific dates
    const dateToIso = date.toISODate()
    return daysOff.includes(dateToIso);

  }

  return (
    <StaticDatePicker
      views={['day']}
      fixedWeekNumber={6}
      value={value}
      onChange={(newValue) => {
        setValue(newValue);
      }}
      slots={{
        actionBar: () => null,
        toolbar: !readOnly ? ({className}) =>  CustomToolbar({setValue, className, months}) : () => null,
        leftArrowIcon: !readOnly ? ({className}) => <ArrowLeftIcon className={className}/> : () => null,
        rightArrowIcon: !readOnly ? ({className}) => <ArrowRightIcon className={className}/> : () => null,
      }}
      disablePast
      showDaysOutsideCurrentMonth={!readOnly}
      disableHighlightToday={readOnly}
      readOnly={readOnly}
      shouldDisableDate={shouldDisableDate}
    />
  );
};


NextApptCalendar.propTypes = {
  value: PropTypes.object,
  setValue: PropTypes.func,
  readOnly: PropTypes.bool
}

export default NextApptCalendar;
